/**
 * Join labels into a readable list: "a", "a and b", "a, b, and c".
 *
 * Findings are read by an operator deciding what to fix, so a bare
 * `parts.join(', ')` costs them a beat working out whether the last item is one
 * more problem or part of the previous one.
 */
export function humanJoin(parts: string[]): string {
  if (parts.length <= 1) return parts.join('');
  if (parts.length === 2) return `${parts[0]} and ${parts[1]}`;

  return `${parts.slice(0, -1).join(', ')}, and ${parts[parts.length - 1]}`;
}
